import { Injectable } from '@angular/core';
import { ConsumeService } from './consume.service';
import { environment } from 'src/environments/environment';
import { Observable, firstValueFrom, map, pipe, tap } from 'rxjs';
import { JwtHelperService } from './jwt-helper.service';
import { ModalService } from './modal-service.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class KeycloakCustomService {

  constructor(
    private consume: ConsumeService,
    private jwtHelperService: JwtHelperService,
    private modalService: ModalService,
    private router: Router
  ) { }

  isLoggin(showAlert: boolean = true) {
    try {
      const token = this.token;
      if (!token) {
        return false;
      }

      const isTokenExpired = this.jwtHelperService.isTokenExpired(this.token, 10);
      if (!isTokenExpired) {
        return true;
      }

      const isRefreshTokenExpired = this.jwtHelperService.isTokenExpired(this.refreshToken, 10);
      if (!isRefreshTokenExpired) {
        return true;
      }

      if (showAlert) {
        this.modalService.openAlertNotLogged().then((result) => {
          result ? this.router.navigate(['/profile']) : this.router.navigate(['/home']);
        });
      }
      this.logout();
      return false;
    } catch (error) {
      return false;
    }
  }

  isLoggedIn() {
    try {
      const token = this.token;
      if (!token) {
        return false;
      }

      const isTokenExpired = this.jwtHelperService.isTokenExpired(this.token, 10);
      if (!isTokenExpired) {
        return true;
      }

      const isRefreshTokenExpired = this.jwtHelperService.isTokenExpired(this.refreshToken, 10);
      if (!isRefreshTokenExpired) {
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  doRefreshToken(): Observable<any> {
    return this.consume.httpPost<any>(`${environment.clientesPublicUrlV3}/refresh-token`, {
      refreshToken: this.refreshToken
    }).pipe(
      tap((data) => {
        const { access_token, refresh_token  } = data.data;
        this.token = access_token;
        this.refreshToken = refresh_token;
      })
    );
  }

  getToken(): Promise<string> {
    return firstValueFrom(
      this.consume.httpPost<any>(`${environment.clientesPublicUrlV3}/refresh-token`, {
        refreshToken: this.refreshToken
      }).pipe(
        tap((data) => {
          const { access_token, refresh_token  } = data.data;
          this.token = access_token;
          this.refreshToken = refresh_token;
        }),
        map(({data}) => data.access_token)
      )
    );
  }

  loadUserProfile() {
    return this.consume.httpGet<Keycloak.KeycloakProfile>(`${environment.keycloak.url}/realms/master/account`, null, {
      Accept: 'application/json',
      Authorization: `Bearer ${this.token}`
    });
  }

  loadSalesforceUserProfile() {
    return this.consume.httpGet<Keycloak.KeycloakProfile>(`${environment.clientesUrlV3}/user-by-email/${this.salesforceEmail}`, null, {
      Accept: 'application/json',
      Authorization: `Bearer ${this.token}`
    }).pipe(
      map((data: any) => data.data)
    );
  }

  getUserRoles(userId: string) {
    return this.consume.httpGet<Keycloak.KeycloakProfile>(`${environment.clientesUrlV3}/user-roles/${userId}`, null, {
      Accept: 'application/json',
      Authorization: `Bearer ${this.token}`
    }).pipe(
      map((data: any) => data.data)
    );
  }

  isUserSalesforce(userId: string) {
    return this.consume.httpGet<Keycloak.KeycloakProfile>(`${environment.clientesUrlV3}/user-roles/${userId}`, null, {
      Accept: 'application/json',
      Authorization: `Bearer ${this.token}`
    }).pipe(
      map((data: any) => {
        const isSalesforce = data.data.some((role: any) => role.name === 'salesforce-viewer');
        return isSalesforce;
      }),
    );
  }

  get token() {
    try {
      const token = localStorage.getItem('access_token');
      return token;
    } catch (error) {
      return null;
    }
  }

  set token(token: string | null) {
    try {
      if (token) {
        localStorage.setItem('access_token', token);
      } else {
        localStorage.removeItem('access_token');
      }
    } catch (error) {
    }
  }

  get refreshToken() {
    try {
      const token = localStorage.getItem('refresh_token');
      return token;
    } catch (error) {
      return null;
    }
  }

  set clientEmailSupport(token: string | null) {
    try {
      if (token) {
        localStorage.setItem('client_email', token);
      } else {
        localStorage.removeItem('client_email');
      }
    } catch (error) {
    }
  }

  get clientEmailSupport() {
    try {
      const email = localStorage.getItem('client_email');
      return email;
    } catch (error) {
      return null;
    }
  }

  set salesforceEmail(token: string | null) {
    try {
      if (token) {
        localStorage.setItem('salesforce_email', token);
      } else {
        localStorage.removeItem('salesforce_email');
      }
    } catch (error) {
    }
  }

  get salesforceEmail() {
    try {
      const email = localStorage.getItem('salesforce_email');
      return email;
    } catch (error) {
      return null;
    }
  }

  set refreshToken(token: string | null) {
    try {
      if (token) {
        localStorage.setItem('refresh_token', token);
      } else {
        localStorage.removeItem('refresh_token');
      }
    } catch (error) {
    }
  }

  logout(redirectUrl?: string) {
    this.token = null;
    this.refreshToken = null;
    this.salesforceEmail = null;
    this.clientEmailSupport = null;

    if (redirectUrl) {
      window.location.replace(redirectUrl);
    }
  }
}
